export class MissingInformationError extends Error {
  constructor(message, candidates) {
    super(message);
    this.name = 'MissingInformationError';
    this.candidates = candidates;
  }
}
